import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {PropTypes} from 'prop-types';

import * as Actions from "../../../../store/modules/resources";
import * as func from "../../../../utils/functions";
import {objectToQueryString, pushUrl} from "../../../../utils/functions";
import {BASE_PATH, STATUS_NAME} from "../../../../wpconfig";
import ResourceItem from "./item";
import Loading from "../../../etc/loading";

class ResourceSearch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			url : 'wp-admin/admin.php?page=resource&',
			action : 'admin/resources',
			status : 'publish',
			mail_type : 'my',
			modalShow : "false",
			mail_templates: [],
			mail_template_ko_id : 0,
			mail_template_en_id : 0,
			exceptMyOrg : '',
			testMode : '',
			testEmail : '',
			isMailCollectLoding : false,
			isSendMailLoding : false,
			collectedMailData : [],
			collectedResultMessage : '',
			sendResultMessage : ''
		}

		this.argsInputTextEvnet = this.argsInputTextEvnet.bind(this)
		this.recordPerPageChange = this.recordPerPageChange.bind(this)
		this.sendMail = this.sendMail.bind(this)
	}

	argsInputTextEvnet = (event) => {
		event.preventDefault();

		const {dataActions} = this.props;
		let param = this.props.param;
		param[event.target.name] = event.target.value;
		dataActions.setResources({"param": param});

		if (event.key === "Enter") {
			this.search(event);
		}
		return false;
	}

	recordPerPageChange = (event) => {
		event.preventDefault();

		const {dataActions} = this.props;
		let param = this.props.param;
		param[event.target.name] = event.target.value;
		dataActions.setResources({"param": param});

		setTimeout(() => {
			this.search(event);
		}, 0);
	}

	search = (event) => {
		event.preventDefault();
		// event.stopPropagation();

		func.getData(this.state.action, this.props.param).then((response) => {
			response.checkedRecords = []
			this.props.dataActions.setResources(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
		});
		return false;
	}

	linkDetail = (event) => {
		event.preventDefault()

		window.location.href = "admin.php?" + window.location.href.split("?")[1] + "&record_id=&tab_id=0";
	}

	onChange = (event) => {
		event.preventDefault()

		let state = this.state;
		state[event.target.name] = event.target.value;
		this.setState(state)
		this.forceUpdate()
	}

	onChecked = (event) => {
		let state = this.state;
		state[event.target.name] = event.target.value;
		this.setState(state)
		this.forceUpdate()

		// 메일에서만 사용하고 있어서 예외처리 안함
		this.getMailTemplate()
	}

	onOpenPopup = (event) => {
		event.preventDefault()

		let state = this.state;
		state['modalShow'] = 'true'
		state['sendResultMessage'] = ''
		state['collectedResultMessage'] = ''
		this.setState(state)
		this.forceUpdate()

		// 메일에서만 사용하고 있어서 예외처리 안함
		this.getMailTemplate()
	}

	onClosePopup = (event) => {
		event.preventDefault()

		let state = this.state;
		state['modalShow'] = 'false'
		this.setState(state)
		this.forceUpdate()
	}

	statusAction = (event) => {
		event.preventDefault()

		if (this.props.checkedRecords <= 0) {
			alert('하나 이상 선택해주세요.')
			return
		}

		if(this.state.status === 'delete') {
			if(confirm('정말로 삭제하시겠습니까?')) {
				func.updateData('admin/resource/delete_trash' , this.props.param).then((response) => {
					func.getData(this.state.action, this.props.param).then((response) => {
						response.checkedRecords = []
						this.props.dataActions.setResources(response);
					});
				});
			}
		} else {
			let param = {
				ids : this.props.checkedRecords,
				status : this.state.status
			}
			func.updateData('admin/resource/status' , param).then((response) => {
				func.getData(this.state.action, this.props.param).then((response) => {
					this.props.dataActions.setResources(response);
				});
			});
		}
	}

	sendMail = (isPreview = false) => {
		if (typeof isPreview === 'boolean') {
		} else {
			isPreview = false
		}

		if (this.props.checkedRecords <= 0) {
			alert('하나 이상 선택해주세요.')
			return
		}

		let state = this.state;
		// 메일 발송 결과 출력
		state['isSendMailLoding'] = true
		state['sendResultMessage'] = ''

		this.setState(state);
		this.forceUpdate();

		let param = this.state.collectedMailData;
		param.templateIdKo = this.state.mail_template_ko_id;
		param.templateIdEn = this.state.mail_template_en_id;
		param.resourceLimitYear = this.state.resourceLimitYear;
		param.resourceLimitToYear = this.state.resourceLimitToYear;
		param.isPreview = isPreview;
		// console.log(param)

		func.updateData('sendmail/send/'+this.state.mail_type+'data' , param).then((response) => {
			// console.log('발송/미리보기')
			// console.log(response)
			if(isPreview) {
				const form = document.createElement('form');
				form.method = 'POST';
				form.action = 'https://lib.pusan.ac.kr/scholar/?action=rm_sendmail_preview';

				const jsonString = JSON.stringify(response.detail);

				// JSON 데이터를 폼에 추가
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = 'data';
				input.value = jsonString;
				form.appendChild(input);

				state['isSendMailLoding'] = false
				this.setState(state);

				const newWindow = window.open('', '_blank');
				newWindow.document.body.appendChild(form);
				form.submit();
			} else {
				// 메일 발송 결과 출력
				state['sendResultMessage'] = '발송건수 : ' + response.send_count + '건 | ' +
					'실패건수 : ' + response.fail_count + '건 | ' +
					'수신거부  : ' + response.reject_count + '건 | ' +
					'메일없음  : ' + response.nomail_count + '건\n';
				if (response.reject_count > 0) {
					state['sendResultMessage'] += '수신거부 Author ID: ' + response.reject_author_ids.join(', ') + '\n';
				}
				if (response.nomail_count > 0) {
					state['sendResultMessage'] += '메일없음 Author ID: ' + response.nomail_author_ids.join(', ') + '\n';
				}
				state['sendResultMessage'] += '자세한 이력은 분석의 메일발송이력에서 확인하세요.';
				state['isSendMailLoding'] = false
				this.setState(state);
				this.forceUpdate();
			}
		});
	}

	previewSendMail = () => {
		this.sendMail(true);
	}

	mailCollection = () => {
		if (this.props.checkedRecords <= 0) {
			alert('하나 이상 선택해주세요.')
			return
		}

		let state = this.state;
		// 메일 발송 결과 출력
		state['isMailCollectLoding'] = true
		state['collectedResultMessage'] = ''

		this.setState(state);
		this.forceUpdate();

		let param = {
			resourceIds : this.props.checkedRecords,
			resourceLimitYear: this.state.resourceLimitYear,
			resourceLimitToYear: this.state.resourceLimitToYear,
			exceptMyOrg: this.state.exceptMyOrg
		}
		// console.log('param')
		// console.log(param);

		func.updateData('sendmail/'+this.state.mail_type+'data/', param).then((response) => {
			console.log('수집')
			console.log(response)
			state['collectedMailData'] = response;
			// 메일 발송 대상 수집결과 출력
			// let state = this.state;
			if(this.state.mail_type === 'my') {
				state['collectedResultMessage'] = '[본인확인] ';
			} else if(this.state.mail_type === 'co') {
				state['collectedResultMessage'] = '[공저홍보] ';
			} else if(this.state.mail_type === 'favor') {
				state['collectedResultMessage'] = '[관심연구자] ';
			}
			state['collectedResultMessage'] += '논문건수 : ' + response.resourceCount + '건 | ' +
				'메일발송 예상건수 : ' + response.totalCount + '건 | ' +
				'수신거부  : ' + response.rejectCount + '건 | ' +
				'메일없음  : ' + response.noMailCount + '건\n';
			if(response.rejectCount > 0) {
				state['collectedResultMessage'] += '수신거부 Author ID: ' + response.rejectAuthorIds.join(', ') + '\n';
			}
			if(response.noMailCount > 0) {
				state['collectedResultMessage'] += '메일없음 Author ID: ' + response.noMailAuthorIds.join(', ') + '\n';
			}

			state['collectedResultMessage'] += '메일 발송을 원하시면 아래 발송하기 버튼을 실행해 주세요.';
			state['isMailCollectLoding'] = false
			this.setState(state);
			this.forceUpdate();
		});
	}

	getMailTemplate = () => {
		// 메일 템플릿 불러오기
		let state = this.state;

		state['mail_templates'] = [];
		state['mail_template_ko_id'] = 0;
		state['mail_template_en_id'] = 0;

		this.setState(state)
		this.forceUpdate()

		const mail_templates = []
		let mail_template_ko_id = 0;
		let mail_template_en_id = 0;

		func.getData('sendmail/setting/', {}).then((response) => {
			{Object.keys(response).map((key, index) => {
				if (key.includes(this.state.mail_type)) {
					response[key].map((item, idx) => {
						mail_templates.push(item);
						if(item.mail_default == 'y') {
							if(item.mail_type == "co-en")
								mail_template_en_id = item.ID
							else
								mail_template_ko_id = item.ID
						}
					});
				}
			})}
			state['mail_templates'] = mail_templates;
			state['mail_template_ko_id'] = mail_template_ko_id;
			state['mail_template_en_id'] = mail_template_en_id;
			state['resourceLimitYear'] = response.resourceLimitYear ? response.resourceLimitYear : '';
			state['resourceLimitToYear'] = response.resourceLimitToYear ? response.resourceLimitToYear : '';
			state['exceptMyOrg'] = response.exceptMyOrg ? response.exceptMyOrg : '';
			state['testMode'] = response.testMode ? response.testMode : '';
			state['testEmail'] = response.testEmail ? response.testEmail : '';

			this.setState(state)
			this.forceUpdate()
		});
	}
	render() {
		return (
			<>
				<div className="d-flex justify-content-center mb-3">
					<div className="form-inline">
						<input type="text" className="form-control form-control-lg top-search mr-1" id="ks" name="ks"
						       defaultValue={this.props.param.ks} onKeyUp={this.argsInputTextEvnet} />
						<button type="button" className="btn btn-primary btn-top-search" onClick={this.search}>Search</button>
					</div>
				</div>
				<div className="d-flex mb-1">
					<div className="">
						<select className="form-control d-inline-block mr-1"
						        name="status" onChange={this.onChange}
						        style={{width : "100px", height: '32px', marginRight: "6px !important"}}
						        value={this.state.status}>
							{Object.keys(STATUS_NAME).map((item, index) => {
								return (<option key={index} value={item}>{STATUS_NAME[item]}</option>)
							})}
						</select>
						<a href="#" className="btn btn-outline-secondary btn-sm resource-update-status mr-2" onClick={this.statusAction}>
							{this.state.status === 'delete' ? '휴지통 모두 비우기' : '상태 변경'}</a>
						<a name="modalShow"
						   onClick={this.onOpenPopup}
						   className="btn btn-outline-secondary btn-sm resource-sendmail mr-1">메일 발송</a>
					</div>
					<div className="ml-auto">
						<select className="form-control mr-3 d-inline-block"
						        name="record_per_page" onChange={this.recordPerPageChange}
						        style={{width : "100px", height: '32px', marginRight: "6px !important"}}
						        value={this.props.param.record_per_page}>
							{[20, 30, 50, 70, 100].map((item, index) => {
								return (<option key={index} value={item}>{item}</option>)
							})}
						</select>
						<a href="#" onClick={this.linkDetail} className="btn btn-success btn-sm">추가</a>
					</div>
				</div>
				{this.state.modalShow === 'true' &&
					<div id="resource_sendmail_option" className="modal-mask modal-rm">
						<div className="modal-wrapper">
							<div className="modal-container modal-content">
								<div className="modal-header"><h1 className="modal-title">메일 보내기</h1>
									<button type="button" className="close" onClick={this.onClosePopup}>
										<span aria-hidden="true" onClick={this.onClosePopup}>×</span></button>
								</div>
								<div className="modal-body">
									<div className="row">
										<div className="col-12">
											<div className={this.state.testMode === 'y' ? "info-message p-2 bg-danger mb-2 text-white" : "info-message"}>
												<ul>
													{this.state.testMode === 'y' &&
														<li>
															<h6 className="text-center">테스트 발송 모드</h6>
															테스트 모드이며, 모든 메일은 {this.state.testEmail}에게 발송됩니다.
														</li>
													}
													<li>검증이 완료된 논문만 메일이 발송됩니다.</li>
												</ul>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-12">
											<h6 className="mb-2">메일유형</h6>
										</div>
									</div>
									<div className="row">
										<div className="col">
											<div className="input-group mb-2">
												<div className="form-check form-check-inline mr-3">
													<input className="form-check-input" type="radio" name="mail_type"
													       checked={this.state.mail_type === 'my'} id="my" value="my"
													       onChange={this.onChecked}/>
													<label htmlFor="my" className="form-check-label">본인확인</label>
												</div>
												<div className="form-check form-check-inline">
													<input className="form-check-input" type="radio" name="mail_type"
													       checked={this.state.mail_type === 'co'} id="co" value="co"
													       onChange={this.onChecked}/>
													<label htmlFor="co" className="form-check-label">공저홍보</label>
												</div>
												<div className="form-check form-check-inline">
													<input className="form-check-input" type="radio" name="mail_type"
														   checked={this.state.mail_type === 'favor'} id="favor" value="favor"
														   onChange={this.onChecked}/>
													<label htmlFor="favor" className="form-check-label">관심연구자</label>
												</div>
											</div>
										</div>
									</div>
									{this.state.mail_type === 'my' &&
										<div className="row">
											<div className="col-12">
												<p>논문의 저자에게 본인확인을 요청합니다.</p>
											</div>
										</div>
									}
									{this.state.mail_type === 'co' &&
										<div className="row">
											<div className="col-12">
												<p>과거 논문의 저자와 공저했던 다른 저자에게 논문이 발표되었음을 알리는 메일을 발송합니다.</p>
											</div>
										</div>
									}
									{this.state.mail_type === 'favor' &&
										<div className="row">
											<div className="col-12">
												<p>관심 연구자의 논문이 발표되었음을 알리는 메일을 발송합니다.</p>
											</div>
										</div>
									}

									<div className="row">
										<div className="col-12">
											<h6 className="mb-2">템플릿 선택</h6>
										</div>
									</div>
									<div className="row">
										{
											this.state.mail_type === 'my' ? (
												<div className="col-12" style={this.state.mail_templates.length <= 0 ? { width: '100px', display: 'flex' } : null}>
													{this.state.mail_templates.length <= 0 ?
														<Loading/> :
														<select className="form-control d-inline-block mr-1"
																name="mail_template_ko_id" onChange={this.onChange}
																style={{width : "300px", height: '32px', marginRight: "6px !important"}}
																value={this.state.mail_template_ko_id}>
															{this.state.mail_templates.map((item, index) => {
																return (<option key={item.ID} value={item.ID}>{item.post_title}</option>)
															})}
														</select>
													}
												</div>
											) : this.state.mail_type === 'favor' ? (
												<div className="col-12" style={this.state.mail_templates.length <= 0 ? { width: '100px', display: 'flex' } : null}>
													{this.state.mail_templates.length <= 0 ?
														<Loading/> :
														<select className="form-control d-inline-block mr-1"
																name="mail_template_ko_id" onChange={this.onChange}
																style={{width : "300px", height: '32px', marginRight: "6px !important"}}
																value={this.state.mail_template_ko_id}>
															{this.state.mail_templates.map((item, index) => {
																return (<option key={item.ID} value={item.ID}>{item.post_title}</option>)
															})}
														</select>
													}
												</div>
											) :
												this.state.mail_templates.length <= 0 ?
													<Loading/> :
													<>
														<div className="col-6" style={this.state.mail_templates.length <= 0 ? { width: '100px', display: 'flex' } : null}>
															<p className="mb-0">국문 템플릿</p>
															<select className="form-control d-inline-block mr-1"
																	name="mail_template_ko_id" onChange={this.onChange}
																	style={{width : "300px", height: '32px', marginRight: "6px !important"}}
																	value={this.state.mail_template_ko_id}>
																{this.state.mail_templates.map((item, index) => {
																	if(item.mail_type == 'co-ko')
																		return (<option key={item.ID} value={item.ID}>{item.post_title}</option>)
																})}
															</select>
														</div>
														<div className="col-6" style={this.state.mail_templates.length <= 0 ? { width: '100px', display: 'flex' } : null}>
															<p className="mb-0">영문 템플릿</p>
															<select className="form-control d-inline-block mr-1"
																	name="mail_template_en_id" onChange={this.onChange}
																	style={{width : "300px", height: '32px', marginRight: "6px !important"}}
																	value={this.state.mail_template_en_id}>
																{this.state.mail_templates.map((item, index) => {
																	if(item.mail_type == 'co-en')
																		return (<option key={item.ID} value={item.ID}>{item.post_title}</option>)
																})}
															</select>
														</div>
													</>
										}
									</div>

									<div className="row">
										<div className="col-12">
											<div className="text-center p-3">
												{this.state.isMailCollectLoding ?
													<Loading/> :
													<button type="button" className="btn btn-primary btn-sm get-sendmail-data" onClick={this.mailCollection}>메일 발송 대상 수집하기</button>
												}
											</div>
										</div>
									</div>

									<div id="getSendmailDataWrap">
										<div className="row">
											<div className="col-12">
												<h6 className="mb-2">메일대상 수집 결과</h6>
											</div>
										</div>
										<div className="row">
											<div className="col-12">
												<div className="mb-2">
													<div data-spy="scroll" data-target="#get-sendmail-data-result" className="border p-2 sendmail-notice-1" data-offset="0">
														{this.state.collectedResultMessage}
													</div>
												</div>
											</div>
										</div>
									</div>

									<div id="excuteSendmailWrap">
										<div className="row">
											<div className="col-12">
												<div className="text-center p-3">
													{this.state.isSendMailLoding ?
														<Loading/> :
														<>
															<button type="button" className="btn btn-danger btn-sm mr-2 execute-sandmail" onClick={this.sendMail}>메일 발송하기</button>
															<button type="button" className="btn btn-dark btn-sm priview-sendmail" onClick={this.previewSendMail}>미리보기</button>
														</>
													}
												</div>
											</div>
										</div>
									</div>


									<div id="excuteSendmailResultWrap">
										<div className="row">
											<div className="col-12">
												<h6 className="mb-2">메일발송 결과</h6>
											</div>
										</div>
										<div className="row">
											<div className="col-12">
												<div className="mb-2">
													<div data-spy="scroll" data-target="#execute-sendmail-result" className="border p-2 sendmail-notice-1" data-offset="0">
														{this.state.sendResultMessage}
													</div>
												</div>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				}
			</>
		)
	}
}

export default connect(
	(state) => ({
		param: state.resources.param ? state.resources.param : {},
		checkedRecords: state.resources.checkedRecords ? state.resources.checkedRecords : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(ResourceSearch)
